module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_List_16"],"path":[{"$":{"d":"M5,9H2V6H5ZM5,1H2V4H5ZM5,11H2v3H5Zm9-4H7V8h7Zm0-5H7V3h7Zm0,10H7v1h7Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_List_16.svg
// module id = Ccj4
// module chunks = 1